export class Settings{
    static url = 'https://feuerwehr-server.org:5000';
}